module.exports = __webpack_public_path__ + "img/logo.c7afd66f.png";